import { render, staticRenderFns } from "./Icon.vue?vue&type=template&id=60d70026&"
import script from "./Icon.vue?vue&type=script&lang=js&"
export * from "./Icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nicholashaskell/Local/kicknic/app/public/wp-content/themes/kicknic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60d70026')) {
      api.createRecord('60d70026', component.options)
    } else {
      api.reload('60d70026', component.options)
    }
    module.hot.accept("./Icon.vue?vue&type=template&id=60d70026&", function () {
      api.rerender('60d70026', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/scripts/components/Icon.vue"
export default component.exports